<template>
    <div class="step --skin-concern">
        <h1 class="step__question">
            <span>What concerns you most about your skin?</span>
        </h1>
        <p class="step__notes">You can select multiple.</p>

        <ul class="step__answers-wrapper --skin-concern">
            <li v-for="(skin_concern,i) in options" class="step__answer --skin-concern --btn" :key="i">
                <button @click="increment(i)" :class="{ '--chosen': concerned_with(i) }">{{ skin_concern }}</button>
            </li>
        </ul>
    </div>
</template>

<script>
import { bus } from '../../utilities'
import logic from '../../data/logic'

export default {
    name: 'SkinConcerns',
    data() {
        return {
            options: logic.quiz[4].options.filter(o=>!/multiple/i.test(o)),
            concerns: [],
            number_of_concerns: 0
        }
    },
    methods: {
        increment(index) {
            if (this.concerned_with(index)) {
                this.concerns = this.concerns.filter(c => c !== index)
                this.number_of_concerns = this.number_of_concerns - 1
            } else {
                this.concerns.push(index)
                this.number_of_concerns = this.number_of_concerns + 1
            }

            this.announce()
        },
        announce() {
            if (this.concerns.length) {
                bus.$emit('answer::chosen', this.concerns.join(','))
            } else {
                bus.$emit('answer::chosen', null)
            }
        },
        concerned_with(index) {
            return this.concerns.some(c => c === index)
        }
    }
}
</script>


// WEBPACK FOOTER //
// source/app/js/components/sections/skin-concerns.vue